module.exports = __webpack_public_path__ + "img/receipt.e3dc8659.png";